<script lang="ts" setup>
import { ref } from 'vue'

import { contactUsConfig as rocnovelConfig } from './configs/rocnovel'




















import ContactUsPageDefault from './components/ContactUsPage.default.vue'



import { api } from '@/api'
import { useToastStore } from '@/stores'
import { isValidEmail } from '@/utils'
import { loadBrandComponent, loadBrandConfig } from '@/utils/loadBrandConfig'

// 🔥 加载当前品牌配置（构建时 tree-shaking）
const config = loadBrandConfig({ rocnovel: rocnovelConfig })

const ContactUsPage = loadBrandComponent({ rocnovel: ContactUsPageDefault })

const { $toast } = useToastStore()

const des = ref('')
const email = ref('')
const loading = ref(false)

async function handleConfirm() {
  if (!isValidEmail(email.value)) {
    $toast(config.texts.emailErrorToast)
    return
  }

  loading.value = true

  try {
    const res = await api.post<PostIssueSubmitBody, PostIssueSubmitResponse>('/issue/submit', {
      issue: des.value,
      email: email.value,
    })

    if (res.code === 0 && res.data === true) {
      $toast(config.texts.successToast)
      des.value = ''
      email.value = ''
    }
    else {
      $toast(config.texts.failToast)
    }
  }
  catch (error: any) {
    $toast(error?.msg || config.texts.failToast)
  }
  finally {
    loading.value = false
  }
}
</script>

<template>
  <ContactUsPage
    :config="config"
    :des="des"
    :email="email"
    :loading="loading"
    :handle-confirm="handleConfirm"
    @update:des="des = $event"
    @update:email="email = $event"
  />
</template>
